import React from "react"
import { Box, Button, Container, Divider, Paper, Stack, Typography } from "@mui/material"

const Support = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "background.default",
        backgroundImage:
          "radial-gradient(1200px 600px at 10% 0%, rgba(33, 150, 243, 0.12), transparent 60%), radial-gradient(900px 500px at 90% 10%, rgba(76, 175, 80, 0.12), transparent 55%)",
        py: { xs: 6, md: 10 }
      }}>
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper"
          }}>
          <Stack spacing={4}>
            <Stack spacing={1}>
              <Typography variant="overline" sx={{ letterSpacing: 2, color: "text.secondary" }}>
                Apple App Store Support
              </Typography>
              <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
                BroStrike Support
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Need help with the iOS version of BroStrike? We are here to help with account access, gameplay issues,
                and general questions.
              </Typography>
            </Stack>

            <Divider />

            <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Contact us
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Email us at{" "}
                <Box component="span" sx={{ fontWeight: 600 }}>
                  support@brostrike.com
                </Box>{" "}
                and include your device model, iOS version, and any screenshots that help explain the issue.
              </Typography>
            </Stack>

            {/* <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Billing and subscriptions
              </Typography>
              <Typography variant="body1" color="text.secondary">
                All purchases are handled by Apple. For refunds or subscription changes, visit your Apple ID
                subscriptions in the App Store.
              </Typography>
            </Stack> */}

            <Stack spacing={1.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Common fixes
              </Typography>
              <Stack spacing={0.75}>
                <Typography variant="body1" color="text.secondary">
                  1. Restart the app and make sure you are on the latest iOS version.
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  2. Check your network connection or switch between Wi-Fi and cellular.
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  3. Reinstall the app if updates or downloads are stuck.
                </Typography>
              </Stack>
            </Stack>

            <Stack spacing={1.5} direction={{ xs: "column", sm: "row" }} alignItems={{ sm: "center" }}>
              <Typography variant="body1" color="text.secondary">
                For account deletion or data requests, email us with the subject "Account Request".
              </Typography>
              <Button
                variant="contained"
                href="mailto:support@brostrike.com"
                sx={{ alignSelf: { xs: "flex-start", sm: "center" }, textWrap: "nowrap" }}>
                Contact Us
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}

export default Support
